module.exports = __webpack_public_path__ + "static/gence350-f457e3c89b470dc4a0ac28c23ecd12d5.png";